var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsgChatUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_225_5259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_5259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.390625C5.81055 0.390625 0.390625 5.81055 0.390625 12.5C0.390625 19.1895 5.81055 24.6094 12.5 24.6094C19.1895 24.6094 24.6094 19.1895 24.6094 12.5C24.6094 5.81055 19.1895 0.390625 12.5 0.390625ZM12.5 5.07812C14.873 5.07812 16.7969 7.00195 16.7969 9.375C16.7969 11.748 14.873 13.6719 12.5 13.6719C10.127 13.6719 8.20312 11.748 8.20312 9.375C8.20312 7.00195 10.127 5.07812 12.5 5.07812ZM12.5 21.875C9.63379 21.875 7.06543 20.5762 5.34668 18.5449C6.26465 16.8164 8.06152 15.625 10.1562 15.625C10.2734 15.625 10.3906 15.6445 10.5029 15.6787C11.1377 15.8838 11.8018 16.0156 12.5 16.0156C13.1982 16.0156 13.8672 15.8838 14.4971 15.6787C14.6094 15.6445 14.7266 15.625 14.8438 15.625C16.9385 15.625 18.7354 16.8164 19.6533 18.5449C17.9346 20.5762 15.3662 21.875 12.5 21.875Z",
    fill: "#0D5F9B"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_225_5259)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -4,
    width: 36,
    height: 36,
    fill: "url(#paint0_linear_225_5259)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_5259",
    x1: 33.5,
    y1: 22.5,
    x2: -4.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#705B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689997,
    stopColor: "#2B9C90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_5259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgChatUserIcon);
export default __webpack_public_path__ + "static/media/ESG-Chat-User-Icon.6fd12c0e267ca146e8893f3600d77ef0.svg";
export { ForwardRef as ReactComponent };